import React, { useState } from "react";

import { Autocomplete, Button, Stack, TextField } from "@mui/material";
import { currenciesArray } from "constants/index";
import { CurrencyType } from "store/types";

interface Props {
  currentCurrency: string | null;
  onSubmit: (result: { currency: CurrencyType | null }) => void;
  onCancel: () => void;
}

export const CurrencyPrompt: React.FC<Props> = ({ currentCurrency, onSubmit, onCancel }) => {
  const [selected, setSelected] = useState<CurrencyType | null>(
    (currenciesArray.find((c) => c === currentCurrency) as CurrencyType) ?? null
  );

  return (
    <Stack sx={{ padding: "24px", gap: "20px", minWidth: "427px" }}>
      <Autocomplete
        options={currenciesArray}
        value={selected}
        onChange={(_, value) => setSelected(value)}
        renderInput={(params) => <TextField {...params} label="Currency" />}
        renderOption={(props, option) => (
          <li {...props} key={option} style={{ fontSize: "16px" }}>
            {option}
          </li>
        )}
        slotProps={{
          listbox: {
            sx: {
              "& .MuiAutocomplete-option": {
                fontSize: "16px",
                "&:hover, &.Mui-focused": { bgcolor: "#edf1f9" },
                "&[aria-selected='true']": { bgcolor: "#edf1f9", "&.Mui-focused": { bgcolor: "#edf1f9" } }
              }
            }
          }
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "& fieldset": { borderColor: "#7b92a9" }
          }
        }}
      />
      <Stack direction="row" justifyContent="flex-end" gap="8px">
        <Button
          onClick={onCancel}
          sx={{
            borderRadius: "32px",
            border: "1px solid #7b92a9",
            color: "#071f35",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px"
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onSubmit({ currency: selected });
          }}
          sx={{
            borderRadius: "32px",
            bgcolor: "#071f35",
            color: "white",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px",
            "&:hover": { bgcolor: "#0a2a45" },
            "&:disabled": { bgcolor: "#bac7ce", color: "white" }
          }}
        >
          Add
        </Button>
      </Stack>
    </Stack>
  );
};
